import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectCoverflow } from "swiper/modules";
import photo1 from "../../images/photo1.png";
import photo2 from "../../images/photo2.png";
import photo3 from "../../images/photo3.png";
import photo4 from "../../images/photo4.png";
import photo5 from "../../images/photo5.png";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import "./photoGallery.css";

const images = [
  photo1,
  photo2,
  photo3,
  photo4,
  photo5,
];

export default function PhotoGallery() {
  return (
    <div className="slider-wrapper">
      <Swiper
        modules={[Navigation, EffectCoverflow]}
        navigation
        loop={true}
        centeredSlides={true}
        slidesPerView={2}
        spaceBetween={20}
        effect="coverflow"
        coverflowEffect={{
          rotate: 0,
          stretch: 10,
          depth: 100,
          modifier: 2,
          slideShadows: false,
        }}
        className="mySwiper"
      >
        {images.map((img, i) => (
          <SwiperSlide key={i}>
            <img src={img} alt={`Slide ${i}`} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
